import _export from '../internals/export.js';
import objectToArray from '../internals/object-to-array.js';

var $ = _export;
var $entries = objectToArray.entries; // `Object.entries` method
// https://tc39.es/ecma262/#sec-object.entries

$({
  target: 'Object',
  stat: true
}, {
  entries: function entries(O) {
    return $entries(O);
  }
});
